import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import i18n from '@/i18n'

Vue.use(Vuetify)

const theme = {
  primary: '#307fc0',
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
